var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Builder"},[_c('div',{staticClass:"Builder__main-content"},[_c('AutomationCanvas'),_c('AutomationSidebar')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }